import { errorToast, successToast } from "@design-system/components/toast";
import { useAction } from "@framework/shared/hooks";
import { trans } from "@mongez/localization";
import { type FormSubmitOptions } from "@mongez/react-form";

export function useSubscribe() {
  const action = useAction("newsletter");

  const handleSubscribe = async ({ values, form }: FormSubmitOptions) => {
    try {
      const value = await action(values);

      if (value.error) {
        return errorToast(value.error);
      }

      form.reset();
      successToast(trans("youSubscribedSuccessfully"));
    } catch (error) {
      errorToast(error as string);
    } finally {
      form.submitting(false);
    }
  };

  return { handleSubscribe };
}
